import { BR, US, ES, FR } from 'country-flag-icons/react/3x2';
import type { Language } from '@/utils/i18n';
import { cn } from '@/lib/utils';

const flags = { 'pt-BR': BR, en: US, es: ES, fr: FR };

/** Inline SVG keeps flags consistent across operating systems, including Windows. */
export function LanguageFlag({ language, className }: { language: Language; className?: string }) {
  const Flag = flags[language];
  return <Flag aria-hidden="true" focusable="false" className={cn('h-4 w-6 shrink-0 rounded-sm overflow-hidden', className)} />;
}
